class PasswordToggle extends HTMLElement {
  connectedCallback() {
    this.initialView = this.querySelector('.password-toggle__initial-view');
    this.trigger = this.querySelector('.password-toggle__trigger');
    this.content = this.querySelector('.password-toggle__content');

    if (!this.initialView || !this.trigger || !this.content) return;

    this._handleToggle = this.toggleContent.bind(this);
    this.trigger.addEventListener('click', this._handleToggle);

    if (this.querySelector('.password-field--error')) {
      this.toggleContent();
    }
  }

  disconnectedCallback() {
    if (this.trigger && this._handleToggle) {
      this.trigger.removeEventListener('click', this._handleToggle);
    }
  }

  toggleContent() {
    this.initialView.hidden = true;
    this.initialView.setAttribute('aria-hidden', 'true');
    this.content.hidden = false;
    this.content.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');

    const focusTarget = this.content.querySelector('input, button, [tabindex]');
    if (focusTarget) focusTarget.focus();
  }
}

customElements.define('password-toggle', PasswordToggle);
